let ctx = null;
let timer = null;

export const getAudioState = () => (ctx ? ctx.state : "none");

export const unlockAudio = async () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return false;
    ctx = new AC();
  }
  if (ctx.state === "suspended") await ctx.resume().catch(() => null);
  return ctx.state === "running";
};

const beep = (freq, start, dur, vol) => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "sine";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0, start);
  g.gain.linearRampToValueAtTime(vol, start + 0.02);
  g.gain.setValueAtTime(vol, start + dur - 0.05);
  g.gain.linearRampToValueAtTime(0, start + dur);
  o.connect(g).connect(ctx.destination);
  o.start(start);
  o.stop(start + dur);
};

export const startRing = (kind = "incoming") => {
  stopRing();
  if (!ctx || ctx.state !== "running") return false;
  const play = () => {
    const t = ctx.currentTime;
    if (kind === "incoming") {
      [0, 0.3, 0.6, 0.9].forEach((d, i) => beep(i % 2 ? 1108 : 880, t + d, 0.24, 0.35));
    } else {
      beep(440, t, 1.0, 0.1);
      beep(480, t, 1.0, 0.1);
    }
  };
  play();
  timer = setInterval(play, kind === "incoming" ? 2000 : 3000);
  return true;
};

export const stopRing = () => {
  if (timer) clearInterval(timer);
  timer = null;
};
